<template>
    <div class="onlinDataWater">
        <onlineData :defaultDeviceType="5"></onlineData>
    </div>
</template>

<script>
import onlineData from "./onlineData.vue"
export default {
    components:{
        onlineData
    }
}
</script>

<style lang="scss" scoped>
.onlinDataWater{
    width: 100%;
    height: 100%;
}
</style>